module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-5.89894522.png";